import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AgendarCita from "../PatientComponent/AgendarCita";
import { alertaGeneral } from "../../utils/alertas";
import apiClient from "../../utils/axiosPetition";
import { useDataUser } from "../../context/dataUserContext";
import { toAppointmentUTC } from "../../utils/appointmentDate";

const PagRespuestaAgendarCitaPayU = () => {
    const preInfo = JSON.parse(localStorage.getItem('selectedDate')) || {};
    const [searchParams] = useSearchParams();
    const transactionState = searchParams.get('transactionState');
    const [isApproved, setIsApproved] = useState(false);
    const { patientId, role } = useDataUser();
    const navigate = useNavigate();

    const [dataCita, setDataCita] = useState({
        doctorId: preInfo.doctorId || '',
        doctor: preInfo.doctor || '',
        servicio: preInfo.servicio || '',
        precioServicio: preInfo.precioServicio || '',
        fecha: preInfo.fecha || '',
        tipoPagador: preInfo.tipoPagador || '',
        tipoConvenio: preInfo.tipoConvenio || 'sin convenio',
        motivoConsulta: preInfo.motivoConsulta || '',
        tipoCita: preInfo.tipoCita || '',
    });

    const onApproved = () => {
        console.log(dataCita);
        const fechaFormateada = toAppointmentUTC(dataCita.fecha);

        // El motivo de consulta va limpio; tipoCita se envía como campo separado
        const notes = dataCita.motivoConsulta || '';

        // Obtener precio del servicio (convertir a número si es string)
        const precio = dataCita.precioServicio ? 
            (typeof dataCita.precioServicio === 'string' ? 
                parseFloat(dataCita.precioServicio.replace(/[^0-9.-]+/g, '')) : 
                Number(dataCita.precioServicio)) : 
            null;

        // Obtener referenceCode de los query params si está disponible
        const referenceCode = searchParams.get('referenceCode') || searchParams.get('reference_code') || null;

        try {
            apiClient.post(
                '/api/clinic/scheduleAppointment',
                {
                    patientId: patientId,
                    date: fechaFormateada,
                    notes: notes,
                    doctorId: dataCita.doctorId, // Enviando el ID del doctor
                    service: dataCita.servicio.replace(/ /g, '_'), // Enviando el servicio seleccionado
                    payerType: dataCita.tipoPagador,
                    covenantType: dataCita.tipoConvenio,
                    tipoCita: dataCita.tipoCita || '',
                    precio: precio,
                    referenceCode: referenceCode,
                    metodoPago: 'payu'
                }
            ).then((response) => {
                if (response.status === 200) {
                    // Verificar si el perfil del paciente está completo
                    const checkProfileComplete = async () => {
                        try {
                            let profileResponse;
                            if (role === 'doctor') {
                                // Para doctores, obtener tu perfil de paciente
                                profileResponse = await apiClient.get('/api/patient/');
                                const patients = profileResponse.data;
                                if (patients && patients.length > 0) {
                                    const doctorPatient = patients[0];
                                    if (!doctorPatient.profileComplete) {
                                        // Perfil incompleto, redirigir al perfil
                                        alertaGeneral({
                                            titulo: 'Cita Agendada',
                                            messageHtml: 'La cita ha sido agendada correctamente.<br/><br/><b>Importante:</b><br/>Para poder acceder a la video consulta, es necesario que completa tu perfil como paciente. Completa todos los datos requeridos.',
                                        }).then(() => {
                                            navigate('/doctor/perfil');
                                        });
                                        return;
                                    }
                                }
                            } else {
                                // Para pacientes regulares
                                profileResponse = await apiClient.get(`/api/patient/${patientId}`);
                                if (!profileResponse.data.profileComplete) {
                                    // Perfil incompleto, redirigir al perfil
                                    alertaGeneral({
                                        titulo: 'Cita Agendada',
                                        messageHtml: 'La cita ha sido agendada correctamente.<br/><br/><b>Importante:</b><br/>Para poder acceder a la video consulta, es necesario que completa tu perfil. Completa todos los datos requeridos.',
                                    }).then(() => {
                                        navigate('/patient/perfil');
                                    });
                                    return;
                                }
                            }
                            
                            // Si el perfil está completo, redirigir a teleconsultas
                            alertaGeneral({ titulo: 'Cita Agendada', messageHtml: 'La cita ha sido agendada correctamente' });
                            navigate('../teleconsultas');
                        } catch (profileError) {
                            console.error('Error verificando perfil:', profileError);
                            // En caso de error, redirigir a teleconsultas de todas formas
                            alertaGeneral({ titulo: 'Cita Agendada', messageHtml: 'La cita ha sido agendada correctamente' });
                            navigate('../teleconsultas');
                        }
                    };
                    
                    checkProfileComplete();
                }
            }).catch((error) => {
                const conflict = error.response?.status === 409;
                alertaGeneral({
                    titulo: conflict ? 'Horario no disponible' : 'Error',
                    messageHtml: error.response?.data?.message || 'Ocurrió un error al agendar la cita',
                    isError: true,
                });
            });

        } catch (error) {
            alertaGeneral({ titulo: 'Error', messageHtml: 'Ocurrió un error al agendar la cita', isError: true });
        }
    };

    useEffect(() => {
        return () => {
            localStorage.removeItem("selectedDate");
        };
    }, []);

    useEffect(() => {
        if (transactionState === "4" && !isApproved) {
            alertaGeneral({
                titulo: "Transacción Aprobada",
                messageHtml: "La transacción fue aprobada, tu cita se agendará en breve",
            }).then(result => {
                onApproved();
                setIsApproved(true);
            });
        } else if (transactionState !== "4") {
            alertaGeneral({
                titulo: "Error",
                messageHtml: "La transacción no fue aprobada",
                isError: true,
            });
        }
    }, [transactionState, isApproved]);

    if (transactionState !== 4) {
        return <AgendarCita />;
    }
};

export default PagRespuestaAgendarCitaPayU;
